import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Grid, TextField, Button, Box,Typography } from '@mui/material';
import { useAlert } from 'react-alert'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import DeleteIcon from '@mui/icons-material/Delete'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Backdrop } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import EditIcon from '@mui/icons-material/Edit'
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
const validationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'), 
});
const MyFormRights = (props) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema)
  });
  const token = localStorage.getItem("Token")
  const [refresh, setRefresh] = useState(false);
  const [submitting, setSubmitting] = useState(false)
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const applyRefresh = () => {
    setRefresh(!refresh);
  };
  const parentId = props.parentId
  const nodeId = props.nodeId
  const [data, setData] = useState({}); 
  const [UpdateData, setUpdateData] = useState({}); 
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUpdateData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };


  const onSubmit = async (data) => {
    window.alert('Initial alert for testing');
    try {
      const postData = {
        ...data,
        name: data.name || props.name,
        id: nodeId,
        description: data.description || "default description",
        createdBy: '', 
        updatedBy: '', 
        isActive: props.isActive, 
        defaultpracticeId: props.defaultpracticeId, 
        value: data.nodesvalues !== undefined ? data.nodesvalues : props.nodesvalues,
        parentId: parentId,
        children: []
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddModules`,
        [postData],
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      // Handle successful response
      console.log('Submission successful:', response.data);
      props.applyRefresh();
      props.handleClose();
  
      // Show success popup
      Swal.fire({
        title: 'Record Added',
        text: 'Record added successfully',
        icon: 'success',
        timer: 1000,
      });
  
    } catch (error) {
      // Handle errors
      console.error('Submission failed:', error);
  
      // Show error popup
      Swal.fire({
        title: 'Error',
        text: 'There was an error adding the record.',
        icon: 'error',
      });
  
    } finally {
      // Optional: Any final operations if needed
      // Example: Reset state, close loading spinner, etc.
    }
  };

  const onSubmitUpdate = async (data) => {
    try {
      const postData = {
        ...data,
        name: data.name || props.name,
        id: nodeId,
        defaultpracticeId: localStorage.getItem('default_paractice'), // Including createdDate from the form data
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/AddModules`,
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      // Handle successful response
      console.log('Submission successful:', response.data);
      props.applyRefresh();
      props.handleClose();
  
      // Show success popup
      Swal.fire({
        title: 'Record Updated',
        text: 'Record updated successfully',
        icon: 'success',
        timer: 1000,
      });
  
    } catch (error) {
      // Handle errors
      console.error('Submission failed:', error);
  
      // Show error popup
      Swal.fire({
        title: 'Error',
        text: 'There was an error updating the record.',
        icon: 'error',
      });
  
    } finally {
      // Optional: Any final operations if needed
      // Example: Reset state, close loading spinner, etc.
    }
  };


  const onDelete = async () => {
    try {
      const postData = {
        id: nodeId, // Assuming you only need the ID for deletion
        isActive: false, // Assuming you want to set the record as inactive or similar
        defaultpracticeId: localStorage.getItem('default_paractice'),
        // Add any other relevant fields here if needed
      };
  
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Module/DeleteModule`, // Adjusted URL to reflect deletion
        postData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
  
      // Handle successful response
      console.log('Submission successful:', response.data);
      setRefresh(!refresh);
      props.applyRefresh();
  
      // Show success popup
      Swal.fire({
        title: 'Record Deleted',
        text: 'Record deleted successfully',
        icon: 'success',
        timer: 1000,
      });
  
      props.handleClose();
  
    } catch (error) {
      // Handle errors
      console.error('Submission failed:', error);
  
      // Show error popup
      Swal.fire({
        title: 'Error',
        text: 'There was an error deleting the record.',
        icon: 'error',
      });
  
    } finally {
      // Optional: Any final operations if needed
      // Example: Reset state, close loading spinner, etc.
    }
  };


  return (
    <>
         {props.update ? (
    <Typography variant="h6" gutterBottom style={{ fontWeight:'bold',marginBottom:-20 }}>
      Update Rights
    </Typography>
  ) : (
    <Typography variant="h6" gutterBottom style={{fontWeight:'bold',marginBottom:-20 }}>
      New Rights
    </Typography>
  )}
      <CancelOutlinedIcon color="primary" onClick={() => props.handleClose()} style={{ float: 'right', marginTop: '-0.8rem', marginRight: '-1.7rem' }} />

      <form onSubmit={props.update == 'update' ? handleSubmit(onSubmitUpdate) : handleSubmit(onSubmit)}>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box mb={2}>
              <label htmlFor="name">Name</label>
              <Controller
                name="name"
                control={control}
                defaultValue={props.name || ''}
                render={({ field }) => (
                  <TextField id="name" fullWidth {...field} error={Boolean(errors.name)} helperText={errors.name ? 'Name is required' : ''} />
                )}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box mb={2}>
              <label htmlFor="nodesvalues">Value</label>
              <Controller
                name="nodesvalues"
                control={control}
                render={({ field }) => (
                  <TextField
                    id="nodesvalues"
                    fullWidth
                    {...field}
                    value={field.value}
                    placeholder={props.nodesvalues === 'string' ? 'Enter value' : props.nodesvalues}
                    error={Boolean(errors.nodesvalues)}
                    helperText={errors.nodesvalues ? 'Value is required' : ''}
                  />
                )}
              />

            </Box>
          </Grid>


          <Grid container alignItems="center">
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={2.5}>
              <Box mt={1.5} display="flex" color="primary" alignItems="center" style={{
                color: '#A574FD', marginTop: '0.1rem'
              }}>
                
         
                <Button onClick={() => props.handleClose()}>
                <ClearIcon color="primary" style={{ marginLeft: '0.2rem',
                color: '#A574FD',
                // marginRight: '-4px',
                paddingLeft: '-4px',
                           }} />
                <span style={{marginLeft:'5px'}}> Cancel</span>  
                </Button>
              </Box>
            </Grid>
            {/* <Grid item xs={0.3}></Grid> */}


            {props.update ? (<>    <Grid item xs={3.8}>
              <Button type="submit"
                style={{ width: '5rem', marginLeft: '0.9rem', height: '30px', color: 'white', paddingRight: '31px' }}
                size="small"
                variant="gradient"
                color="warning"

              >  <SaveOutlinedIcon
              // fontSize="medium"
              style={{

                width: '18px',
                height: '14px',
                color: 'white',
                // paddingRight: '-6px',
                // paddingBottom: '2px',
              }}
            />Update
              </Button>

            </Grid>
              <Grid item xs={1} color="red">


              <>









<DeleteIcon
  style={{
    marginRight: '3px',
    float: 'right',
    marginTop: '5px',
    color: 'red',
    marginLeft: '4px',
  }}
  color="red"
  onClick={() => setIsDialogOpen(true)}
></DeleteIcon>

{/* <Dialog
  open={isDialogOpen}
  onClose={() => setIsDialogOpen(false)}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
  BackdropComponent={Backdrop}
  BackdropProps={{
    invisible: true,
  }}
  PaperProps={{
    style: {
      background: '#cef5f0',
      boxShadow: 'none',
      borderRadius: '8px'
    },
  }}
>
  <div style={{ borderRadius: '8px', width: '22rem', }}>

    <ErrorOutlineIcon style={{ marginLeft: '125px', fontSize: '100px', color: 'orange' }}></ErrorOutlineIcon>
    <DialogTitle style={{ marginLeft: '1rem', fontWeight: 'bold' }}>{"Do you want to delete the record?"}</DialogTitle>
    <h5 style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'normal', marginLeft: '-2rem' }}>
      This action cannot be undone.
    </h5>
    <DialogContent>
      <DialogContentText>
        <Grid style={{ marginLeft: '90px' }}>
          <Button onClick={() => onDelete()} style={{ backgroundColor: 'red', color: 'white' }}>YES</Button>
          <Button onClick={() => setIsDialogOpen(false)} style={{ backgroundColor: 'blue', color: 'white', marginLeft: '1rem' }}>NO</Button>
        </Grid>
      </DialogContentText>
    </DialogContent>
  </div>
</Dialog> */}
          <Dialog
  open={isDialogOpen}
  onClose={() => setIsDialogOpen(false)}
  aria-labelledby="alert-dialog-title"
  aria-describedby="alert-dialog-description"
  BackdropComponent={Backdrop}
  BackdropProps={{
    timeout: 500,
    invisible: true,
  }}
  PaperProps={{
    style: {
      background: '#cef5f0',
      boxShadow: 'none',
      borderRadius: '8px',
      padding: '20px',
    },
  }}
>
  <div style={{ textAlign: 'center', width: '100%' }}>
    <ErrorOutlineIcon style={{ fontSize: '100px', color: 'black' }}></ErrorOutlineIcon>
    <DialogTitle id="alert-dialog-title" style={{ fontWeight: 'bold', marginBottom: '20px' }}>
      {"Do you want to delete the record?"}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'center', marginBottom: '20px' }}>
      <Button onClick={() => onDelete()} variant="contained" color="error">
        YES
      </Button>
      <Button onClick={() => setIsDialogOpen(false)} variant="outlined" color="primary" style={{ marginLeft: '1rem' }}>
        NO
      </Button>
    </DialogActions>
  </div>
</Dialog>
</>


              </Grid>  </>

            ) : (<>
              <Grid item xs={3.5}>
                <Button type="submit"
                  style={{ width: '29px', marginLeft: '0.9rem', height: '30px', color: 'white' }}
                  size="medium"
                  variant="gradient"
                  color="warning"

                >
                  
                  <SaveOutlinedIcon
                      fontSize="medium"
                      style={{

                        width: '18px',
                        height: '14px',
                        color: 'white',
                        paddingRight: '-4px',
                        paddingBottom: '2px',
                      }}
                    />SAVE
                </Button>

              </Grid>
              <Grid item xs={1}>


                <>








{/* 
                  <DeleteIcon
                    style={{
                      marginRight: '3px',
                      float: 'right',
                      marginTop: '5px',
                      color: 'red',
                      marginLeft: '4px',
                    }}
                    color="red"
                    onClick={() => setIsDialogOpen(true)}
                  ></DeleteIcon>

                  <Dialog
                    open={isDialogOpen}
                    onClose={() => setIsDialogOpen(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      invisible: true,
                    }}
                    PaperProps={{
                      style: {
                        background: '#cef5f0',
                        boxShadow: 'none',
                        borderRadius: '8px'
                      },
                    }}
                  >
                    <div style={{ borderRadius: '8px', width: '22rem', }}>

                      <ErrorOutlineIcon style={{ marginLeft: '125px', fontSize: '100px', color: 'orange' }}></ErrorOutlineIcon>
                      <DialogTitle style={{ marginLeft: '1rem', fontWeight: 'bold' }}>{"Do you want to delete the record?"}</DialogTitle>
                      <h5 style={{ textAlign: 'center', fontSize: '16px', fontWeight: 'normal', marginLeft: '-2rem' }}>
                        This action cannot be undone.
                      </h5>
                      <DialogContent>
                        <DialogContentText>
                          <Grid style={{ marginLeft: '90px' }}>
                            <Button onClick={() => onDelete()} style={{ backgroundColor: 'red', color: 'white' }}>YES</Button>
                            <Button onClick={() => setIsDialogOpen(false)} style={{ backgroundColor: 'blue', color: 'white', marginLeft: '1rem' }}>NO</Button>
                          </Grid>
                        </DialogContentText>
                      </DialogContent>
                    </div>
                  </Dialog> */}
                </>

              </Grid>
            </>
            )}





          </Grid>


        </Grid>
      </form>
    </>

  );
};

export default MyFormRights;
